import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Api } from 'api3';

@Injectable({
  providedIn: 'root',
})
export class Api3Service {
  static apiVersion = `v${environment.api.version}`;
  static apiUrl = `${environment.api.url}`;
  api: Api<any>;

  constructor() {
    this.api = new Api({
      baseUrl: Api3Service.apiUrl,
      baseApiParams: {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    });
  }
}
